import { render, staticRenderFns } from "./GuardSettingPage.vue?vue&type=template&id=5b6d7be0&scoped=true&"
import script from "./GuardSettingPage.vue?vue&type=script&lang=js&"
export * from "./GuardSettingPage.vue?vue&type=script&lang=js&"
import style0 from "./GuardSettingPage.vue?vue&type=style&index=0&id=5b6d7be0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6d7be0",
  null
  
)

export default component.exports